import React from "react"
import Cookies from 'universal-cookie';

import { instance /*, DevBuild*/ } from '../../variables/Config'
import { Branches, BranchNames, HostUrl } from '../../variables/DigmaDef'

const cookies = new Cookies();

export class SelectNetworkURL extends React.Component{
    constructor(props) {
        super(props);    
        this.state = {
          //hosturl: localStorage.getItem('DigmaTechURILocalStorage') ? localStorage.getItem('DigmaTechURILocalStorage') : HostUrl, // instance.get_mainDomain(),  
          //branch:  localStorage.getItem('DigmaTechBranchLocalStorage') || ''
          hosturl: cookies.get('DigmaTechURILocalStorage') ? cookies.get('DigmaTechURILocalStorage') : HostUrl, // instance.get_mainDomain(),  
          branch:  cookies.get('DigmaTechBranchLocalStorage') || ''
        }
    }
    componentDidMount(){
        this.props.setUrl(this.state.hosturl) 
        instance.set_mainDomain(this.state.hosturl)
    }
    selectBranch = event => {
        event.preventDefault()
        let url = event.target.value.includes('https://') ? event.target.value : 'https://' + event.target.value + '.' + Branches[0].replace('https://','')
        this.setState({
            branch: event.target.value,
            hosturl: url
        })
        //this.props.hosturl(url)
        this.props.setUrl(url) 
        instance.set_mainDomain(url) 
        //localStorage.setItem('DigmaTechURILocalStorage', url)
        //localStorage.setItem('DigmaTechBranchLocalStorage', event.target.value)
        cookies.set('DigmaTechURILocalStorage', url, { path: '/' });
        cookies.set('DigmaTechBranchLocalStorage', event.target.value, { path: '/' }); // , domain: url
        console.log('cookie get:', cookies.get('DigmaTechURILocalStorage')); // Pacman
        console.log('cookie get:', cookies.get('DigmaTechBranchLocalStorage')); // Pacman
    }
    render(){
        const { branch } = this.state
        //console.log('SelectNetworkURL branch=', branch)
        return (
            <div className="large form-group login-form">
                <span className="label label-default label-branch">סניף</span>
                <select className='select-branch' onChange={this.selectBranch} value={branch} >
                    {Branches.map((item, index) => <option key={item} value={item} >{BranchNames[index]}</option>)}
                </select>
                <p>{this.state.hosturl}</p>
            </div>
        )
    }
}